// Journal Vuex

import state from './journalStates.js'
import * as getters from './journalGetters.js'
import * as mutations from './journalMutations.js'
import * as actions from './journalActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
